/**
 * Attaches colorbox for the playback of Mantle videos.
 *
 * Templates loading this library need the following:
 *     Data attribute 'playInline' that corresponds to a checkbox value.
 *     .js-video-block as a class on the template wrapper
 *     See example in: editorial/video_block_v1
 */

(function ($, Drupal, generic) {
  var iPhone = (/iPhone|iPod/).test(navigator.userAgent) && !window.MSStream;
  var iPad = (/Pad/).test(navigator.userAgent) && !window.MSStream;

  $(document).on('videoBlock.reAttach', function (context) {
    Drupal.behaviors.videoBlock.attach(context);
  });

  /* Video-ended-final runs after certain async commands that run at
  the end of video playback.*/
  $(document).on('video-ended-final', '#colorbox.colorbox--video', function () {
    $.colorbox.close();
  });

  Drupal.behaviors.videoBlock = {
    observer: null,
    setupObserver: function () {
      /* IntersectionObserver used to detect video blocks that need to be
      initialzed before they are clicked.*/
      var self = this;

      if (self.observer) {
        return;
      }

      var options = {
        root: null,
        rootMargin: '0px',
        threshold: [0.1]
      };
      var handler = function (entries) {
        _.each(entries, function (entry) {
          if (!entry.isIntersecting) {
            return;
          }
          var elem = entry.target;
          self.initializeVideo(elem);
        });
      };

      self.observer = new IntersectionObserver(handler, options);
    },
    /* We want the youtube iframe initialized so we can click to play. But only
    when the video comes into view.
    This is for iOS which has strict rules about the timing between a click
    and when a video plays. */
    initializeVideo: function (videoBlock) {
      var $videoBlock = $(videoBlock);
      var elcVideo = $videoBlock.data('videoManager');
      this.observer.unobserve(videoBlock);
      elcVideo.init();
    },
    attach: function (context) {
      var self = this;
      var $elements = $('.js-video-block', context);

      this.setupObserver();

      /* eslint-disable complexity */
      $elements.each(function () {
        var $module = $(this);
        var elcVideo;
        var parentClasses = '';
        var posterMediaClasses = '';
        self.getDom($module);

        parentClasses = $module.nodes.$videoBlockMedia.length ? $module.nodes.$videoBlockMedia.attr('class') : '';
        $module.nodes.$videoBlock.addClass(parentClasses);
        posterMediaClasses = $module.nodes.$posterMedia.length ? $module.nodes.$posterMedia.attr('class') : '';
        $module.nodes.$videoBlockMedia.addClass(posterMediaClasses).removeClass('mantle-media-asset');

        $module.nodes.$playButton.attr('tabindex', '0');
        $module.nodes.$playButton.on('keyup', function(e) {
          if (e.key === 'Enter') {
            $(this).trigger('click');
          }
        });

        $module.nodes.$posterImages.on('lazyloaded', function() {
          var $this = $(this);
          var topCalculated;
          if (!$module.settings.defaultAspectRatio && !$module.settings.defaultAspectRatioMob && $this.closest('.js-content-block-media-variation').length <= 0) {
            // Calculate padding top for videos: Height / Width * 100
            topCalculated = parseInt($this[0].naturalHeight) / parseInt($this[0].naturalWidth) * 100;
            $this.closest('.js-videojs-video--v1').css('padding-top', topCalculated.toFixed(2) + '%');
          }
        });

        // Need an actual video
        if ($module.nodes.$videoBlock.length === 0) {
          return;
        }

        $module.nodes.$videoBlock.on('video-started', function () {
          var $videoTemplate = $(this).closest('.js-video-block-v1');
          $videoTemplate.addClass('playing-video');
        });

        $module.nodes.$videoBlock.on('video-ended, video-paused', function () {
          var $videoTemplate = $(this).closest('.js-video-block-v1');
          $videoTemplate.removeClass('playing-video');
        });

        // We preload for iOS when the first click needs to trigger play.
        if (iPhone || ($module.settings.playInline && iPad)) {
          self.observer.observe($module.nodes.$videoBlock.get(0));
        }

        if ($module.settings.videoMute && $module.settings.playInline) {
          $module.nodes.$videoJS.attr('muted', true);
        }

        if ($module.settings.videoAutoplay && $module.settings.playInline) {
          new MantleVideo.MantleVideoPlayer($module.nodes.$videoPlayer);
          $module.nodes.$videoJS.attr('autoplay', 1);
          elcVideo = $module.nodes.$videoBlock.data('video-manager');
          elcVideo.init();
        }

        /* Video playback in overlay is the default.
        See if we need to take over the start-video event to handle overlay.*/
        if ($module.settings.playInline) {
          return;
        }

        if (iPhone) {
          // On IOS default to playing in full screen
          $module.nodes.$videoJS.removeAttr('playsinline');
        }

        $module.off('start-video.videoBlock').on('start-video.videoBlock', '.js-videojs-video', function (e) {
          var $videoBlockWrap = $(this);
          var elcVideo = $videoBlockWrap.data('videoManager');

          // Don't let the top level inline stuff handle video blocks.
          e.stopPropagation();

          if (iPhone) {
            /* At this point. We've setup video to not play inline and
            preloaded the iframe via intersection observer. This should
            pop the fullscreen view. */
            elcVideo.startVideo();
            return;
          }

          var $videoClone = elcVideo.clone().removeAttr('style');
          var options = {
            content: $videoClone,
            className: 'colorbox--video ' + $module.attr('class'),
            hideOnClickOutside: true,
            includeBackground: true,
            backgroundNodeClickHide: true,
            cssStyle: {
              width: '100%',
              maxWidth: 1024,
              maxHeight: 768
            },
            onComplete : function () {
              var cloneController = $videoClone.data('videoManager');
              /* So it's "possible" for ipad to play on overlay click. Same
              with iphone. But it comes down to a speed issue. Also, videojs
              currently doesn't handle getting the extra -1 youtube state
              event well.
              NOTE: once mantle_video is in colorbox. it won't be caught by
              start-video.videoBlock. Which is what we want. */
              cloneController.init();

              if (!iPad) {
                cloneController.startVideo();
              }
              $('html,body').addClass('no-scroll');
            },
            onCleanup: function () {
              $('html,body').removeClass('no-scroll');
            }
          };
          generic.overlay.launch(options);
        });
      });

      Unison.on('change', function() {
        // Intentionally setTimeout to detect a new image used between Desktop and Mobile.
        setTimeout(function() {
          $elements.each(function() {
            var $module = $(this);
            var topCalculated;
            self.getDom($module);
            if ($module.nodes.$posterImages.length && $module.nodes.$posterImages.hasClass('lazyloaded') 
              && $module.nodes.$posterImages.closest('.js-content-block-media-variation').length <= 0
              && !$module.settings.defaultAspectRatio  && !$module.settings.defaultAspectRatioMob) {
              // Calculate padding top for videos: Height / Width * 100
              topCalculated = parseInt($module.nodes.$posterImages[0].naturalHeight) / parseInt($module.nodes.$posterImages[0].naturalWidth) * 100;
              $module.nodes.$posterImages.closest('.js-videojs-video--v1').css('padding-top', topCalculated.toFixed(2) + '%');
            }
          });
        }, 1000);
      });
    },

    getDom: function($module) {
      $module.nodes = {};
      $module.settings = {};
      $module.nodes.$videoBlock = $('.js-videojs-video', $module);
      $module.nodes.$videoJS = $('elc-video-js, .video-js', $module.nodes.$videoBlock);
      $module.nodes.$videoBlockMedia = $module.nodes.$videoBlock.closest('.js-video-block-media-video');
      $module.nodes.$videoPlayer = MantleVideo.MantleVideoPlayer.getVideoPlayerDom($module);
      $module.nodes.$posterImages = $('.js-videojs-landing__image img', $module);
      $module.nodes.$posterMedia = $('.js-videojs-landing__image .mantle-media-asset', $module);
      $module.nodes.$playButton = $('.js-videojs-landing__play', $module.nodes.$videoBlock);
      $module.settings.playInline = $module.data('play-inline');
      $module.settings.videoAutoplay = $module.data('autoplay-video');
      $module.settings.videoMute = $module.data('mute-video-on-loading');
      $module.settings.defaultAspectRatio = $module.data('default-aspect-ratio');
      $module.settings.defaultAspectRatioMob = $module.data('default-aspect-ratio-mob');
    }
  };
})(jQuery, Drupal, window.generic || {});
